import React, { Component } from 'react';
import GetUploadImage from './getUploadImage';
import Checkbox from '@material-ui/core/Checkbox';
import '../css_generales/getConfiguracionGlobal.css';
import 'whatwg-fetch';
import { MaterialPicker  } from 'react-color';
class getConfiguracionGlobal extends Component {
  constructor(){
    super();
    this.state = {
        logo:'',
        datos_empresa:'',
        condiciones:'',
        uuid_imagen:'',
        uuid_sucursal:'',
        __color_primario: '#fff',
        __color_terciario:'#fff',
        sw_domicilio:false,
        sw_retirar:false,
        sw_reservar:false,
        dias_reserva:0
    }
  }
  cargar_informacion =()=>{
    const url= this.props.dir_url + "webapp/getDataInformacion";
    const token =  this.props.token
    var obj = { accion:'datainformacion', token};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        //console.log(data)
        this.setState({
          datos_empresa:data[0].msg[0].datos_empresa,
          condiciones:data[0].msg[0].condiciones,
          uuid_imagen:data[0].msg[0].uuid_imagen,
          uuid_sucursal:data[0].msg[0].uuid_sucursal,
          __color_primario:data[0].msg[0].__color_primario,
          __color_terciario:data[0].msg[0].__color_terciario,
          sw_domicilio:(Number(data[0].msg[0].sw_domicilio)===1)?true:false,
          sw_retirar:(Number(data[0].msg[0].sw_retirar)===1)?true:false,
          sw_reservar:(Number(data[0].msg[0].sw_reservar)===1)?true:false,
          dias_reserva:data[0].msg[0].dias_reserva
        })
      }
    })
    .catch(console.log)
  }
  getUUID =(uuid_imagen,id_item)=>{
    this.setState({
      uuid_imagen
    },()=>{
      this.getGrabarInformacion()
    })
  }
  getUUIDS=(uuid_sucursal,id_item)=>{
    this.setState({
      uuid_sucursal
    }, ()=>{
      this.getGrabarInformacion()
    })
  }
  getGrabarInformacion =()=>{
    const url= this.props.dir_url + "webapp/getGrabarInformacion";
    const token =  this.props.token
    const datos_empresa = this.state.datos_empresa
    const condiciones = this.state.condiciones
    const uuid_imagen = this.state.uuid_imagen
    const uuid_sucursal = this.state.uuid_sucursal
    const __color_primario = this.state.__color_primario
    const __color_terciario = this.state.__color_terciario


    const sw_domicilio=(this.state.sw_domicilio===true)?1:0
    const sw_retirar=(this.state.sw_retirar===true)?1:0
    const sw_reservar=(this.state.sw_reservar===true)?1:0
    const dias_reserva= this.state.dias_reserva

    var obj = { accion:'grabarinformacion', token,datos_empresa,condiciones,uuid_imagen,
    uuid_sucursal,__color_primario,__color_terciario,sw_domicilio,sw_retirar,sw_reservar,dias_reserva};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        /*this.setState({
          datos_empresa:data[0].msg[0].datos_empresa,
          condiciones:data[0].msg[0].condiciones,
        })*/
      }
      this.props.get_loading(false)
    })
    .catch(console.log)
    this.props.get_loading(true)
  }
  inputChangedHandlerText1 = (event) => {
    this.setState({
      datos_empresa :event.target.value
    })
  }
  inputChangedHandlerText2 = (event) => {
    this.setState({
      condiciones :event.target.value
    })
  }
  inputChangedHandlerText3 = (event) => {
    this.setState({
      sw_domicilio : event.target.checked
    })
  }
  inputChangedHandlerText4 = (event) => {
    this.setState({
      sw_retirar :event.target.checked
    })
  }
  inputChangedHandlerText5 = (event) => {
    this.setState({
      sw_reservar : event.target.checked
    })
  }
  inputChangedHandlerText6 = (event) => {
    this.setState({
      dias_reserva : event.target.value
    })
  }
  regresar =()=>{
    this.props.get_salir_vista_pedido()
  }
  handleChangeCompleteColor1 = (color) => {
    this.setState({ __color_primario: color.hex });
  };
  handleChangeCompleteColor2 = (color) => {
    this.setState({ __color_terciario: color.hex });
  };

  render() {
    //id_datos_empresa, logo, datos_empresa, condiciones

    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_250x200 =this.props.file_250x200
    const file_500x200 =this.props.file_500x200
    const token_image250x200 = url_image+file_250x200+separator
    const token_image500x200 = url_image+file_500x200+separator
    const ext250x200="_250x200.png?alt=media"
    const ext500x200="_500x200.png?alt=media"


    return(
      <React.Fragment>
      <div className="div_global_registre_U_dataempresa">
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_"></div>
        </div>
        <div  className="div_global_registre_title_U_dataempresa" >
          <span className="span-global-title">Configuración Global</span>
        </div>
        <div className="grid-container-registre_U_dataempresa">
          <div className="div_1_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_1_2_U_dataempresa"><input style={{"width":"100%"}} value={this.state.datos_empresa} onChange={(event)=>this.inputChangedHandlerText1(event)} className="input-global" placeholder="Datos de la Empresa" /></div>
          <div className="div_2_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_2_2_U_dataempresa" ><textarea autoComplete="off" style={{"width":"100%"}} value={this.state.condiciones} onChange={(event)=>this.inputChangedHandlerText2(event)} className="input-global" placeholder="Condiciones" /></div>

          <div className="div_3_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_3_2_U_dataempresa" >

            <GetUploadImage uuid={1} file_xxx={this.props.file_250x200}  firebase={this.props.firebase} getUUID={this.getUUID}
            width={'250px'} height={'200px'} pref={'_250x200'}  token_image={
              (this.state.uuid_imagen)?
              token_image250x200+this.state.uuid_imagen+ext250x200:''
            } />
          </div>
          <div className="div_4_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_4_2_U_dataempresa" >

            <GetUploadImage uuid={1} file_xxx={this.props.file_500x200}  firebase={this.props.firebase} getUUID={this.getUUIDS}
            width={'500px'} height={'200px'} pref={'_500x200'}  token_image={
              (this.state.uuid_sucursal)?
              token_image500x200+this.state.uuid_sucursal+ext500x200:''
            } />
          </div>
          <div className="div_5_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_5_2_U_dataempresa" >
            Color 1
            <MaterialPicker
              color={ this.state.__color_primario }
              onChangeComplete={ this.handleChangeCompleteColor1 }
            />
            Color 2
            <MaterialPicker
              color={ this.state.__color_terciario }
              onChangeComplete={ this.handleChangeCompleteColor2 }
            />
          </div>
          <div className="div_6_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_6_2_U_dataempresa" >
            Servicio a Domicilio
            <Checkbox
              checked={this.state.sw_domicilio}
              onChange={this.inputChangedHandlerText3}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            Servicio para Retirar
            <Checkbox
              checked={this.state.sw_retirar}
              onChange={this.inputChangedHandlerText4}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
            Servicio para Reservar
            <Checkbox
              checked={this.state.sw_reservar}
              onChange={this.inputChangedHandlerText5}
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </div>
          <div className="div_7_1_U_dataempresa">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') } />
          </div>
          <div className="div_7_2_U_dataempresa" >
          <input style={{"width":"100%"}} value={this.state.dias_reserva} onChange={(event)=>this.inputChangedHandlerText6(event)} className="input-global" placeholder="Días de Reserva" />
          </div>
        </div>
        <div  className="div_global_registre_title_U_dataempresa" >
          <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getGrabarInformacion()}>
            GRABAR INFORMACIÓN
          </button>
        </div>
      </div>
      </React.Fragment>
    )
  }
  //id_datos_empresa, logo, datos_empresa, condiciones, __color_primario, __color_secundario, __color_terciario, __logo_general,
  // __color_fondo_letra, __color_lineas, __color_letras, uuid_imagen, uuid_sucursal,
  //cargar_informacion
  componentDidMount (){
    this.cargar_informacion()
  }

}
export default getConfiguracionGlobal;
